import React from 'react';
import {Box, Button, Chip, Container, Grid, Typography} from '@mui/material';
import MedicalServicesOutlinedIcon from '@mui/icons-material/MedicalServicesOutlined';
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined';

const Directions: React.FC = () => {
    const primaryColor = '#062159';
    const accentColor = '#DEE8FF';

    const cardStyles = {
        border: `2px solid ${primaryColor}`,
        borderRadius: '20px',
        p: { xs: 2.5, md: 3 },
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        transition: 'all 0.3s ease',
        backgroundColor: '#fff',
        position: 'relative',
        zIndex: 1,
        '&:hover': {
            boxShadow: '0 6px 20px rgba(6, 33, 89, 0.15)',
            transform: 'translateY(-4px)'
        }
    };

    return (
        <Container maxWidth="lg" sx={{ py: { xs: 4, md: 6 } }}>
            <Typography
                variant="h2"
                sx={{
                    fontSize: { xs: '2.5rem', md: '4rem' },
                    fontWeight: 700,
                    textAlign: 'center',
                    mb: { xs: 4, md: 6 },
                    fontFamily: 'Kyiv Type Serif'
                }}
            >
                Ви можете обрати один з двох напрямків
            </Typography>

            <Grid container rowSpacing={{ xs: 8, md: 0 }} columnSpacing={{ xs: 0, md: 4 }} alignItems="stretch">

                <Grid item xs={12} md={6}>
                    <Box sx={cardStyles}>
                        <MedicalServicesOutlinedIcon sx={{ fontSize: { xs: 40, md: 50 }, color: primaryColor, mb: 1.5 }} />

                        <Typography
                            variant="h3"
                            sx={{
                                fontFamily: 'Kyiv Type Serif',
                                fontWeight: 700,
                                fontSize: { xs: '1.25rem', md: '1.75rem' },
                                color: primaryColor,
                                mb: 1,
                                textAlign: 'center'
                            }}
                        >
                            Medical School
                        </Typography>

                        <Chip
                            label="Медицина та здоров'я"
                            sx={{
                                fontFamily: 'Kyiv Type Sans',
                                backgroundColor: accentColor,
                                color: primaryColor,
                                fontWeight: 600,
                                fontSize: { xs: '0.75rem', md: '0.8rem' },
                                mb: 2,
                                height: '24px'
                            }}
                        />

                        <Box sx={{
                            flexGrow: 1,
                            textAlign: 'center',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'flex-start',
                            pt: 4,
                        }}>
                            <Typography
                                sx={{
                                    fontFamily: 'Kyiv Type Sans',
                                    fontSize: { xs: '0.875rem', md: '1rem' },
                                    lineHeight: 1.5,
                                    mb: 1.5
                                }}
                            >
                                Для тих, хто розглядає медицину як майбутню професію та хочe зрозуміти її зсередини
                            </Typography>

                            <Typography
                                sx={{
                                    fontFamily: 'Kyiv Type Sans',
                                    fontSize: { xs: '0.8rem', md: '0.9rem' },
                                    lineHeight: 1.5,
                                    color: '#444'
                                }}
                            >
                                <strong>Особливість:</strong> співпраця з мережею <strong>«Добробут»</strong>. Учасники
                                відвідають медичний центр та познайомляться з клінічними навичками лікаря
                            </Typography>
                        </Box>

                        <Button
                            variant="outlined"
                            sx={{
                                borderRadius: '50px',
                                borderColor: primaryColor,
                                color: primaryColor,
                                fontFamily: 'Kyiv Type Sans',
                                textTransform: 'none',
                                px: 4,
                                py: 0.5,
                                fontSize: '0.9rem',
                                width: { sm: 'auto' },
                                '&:hover': {
                                    borderColor: primaryColor,
                                    backgroundColor: accentColor
                                }
                            }}
                            href="/pdf/medical.pdf"
                            download="medical.pdf"
                        >
                            Детальніше
                        </Button>
                    </Box>
                </Grid>

                <Grid item xs={12} md={6}>
                    <Box sx={cardStyles}>
                        <AccountBalanceOutlinedIcon sx={{ fontSize: { xs: 40, md: 50 }, color: primaryColor, mb: 1.5 }} />

                        <Typography
                            variant="h3"
                            sx={{
                                fontFamily: 'Kyiv Type Serif',
                                fontWeight: 700,
                                fontSize: { xs: '1.25rem', md: '1.75rem' },
                                color: primaryColor,
                                mb: 1,
                                textAlign: 'center'
                            }}
                        >
                            Financial School
                        </Typography>

                        <Chip
                            label="Фінанси та економіка"
                            sx={{
                                fontFamily: 'Kyiv Type Sans',
                                backgroundColor: accentColor,
                                color: primaryColor,
                                fontWeight: 600,
                                fontSize: { xs: '0.75rem', md: '0.8rem' },
                                mb: 2,
                                height: '24px'
                            }}
                        />

                        <Box sx={{
                            flexGrow: 1,
                            textAlign: 'center',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'flex-start',
                            pt: 4
                        }}>
                            <Typography
                                sx={{
                                    fontFamily: 'Kyiv Type Sans',
                                    fontSize: { xs: '0.875rem', md: '1rem' },
                                    lineHeight: 1.5,
                                    mb: 1.5
                                }}
                            >
                                Для тих, хто хоче розібратися у світі грошей: як працюють інвестиції, що впливає на
                                ринки, як управляти бюджетом
                            </Typography>
                            <Typography
                                sx={{
                                    fontFamily: 'Kyiv Type Sans',
                                    fontSize: { xs: '0.8rem', md: '0.9rem' },
                                    lineHeight: 1.5,
                                    color: '#444'
                                }}
                            >
                                Ви навчитеся приймати фінансово обґрунтовані рішення та зрозумієте принципи роботи
                                сучасної економіки
                            </Typography>
                        </Box>

                        <Button
                            variant="outlined"
                            sx={{
                                borderRadius: '50px',
                                borderColor: primaryColor,
                                color: primaryColor,
                                fontFamily: 'Kyiv Type Sans',
                                textTransform: 'none',
                                px: 4,
                                py: 0.5,
                                fontSize: '0.9rem',
                                width: { xs: '100%', sm: 'auto' },
                                '&:hover': {
                                    borderColor: primaryColor,
                                    backgroundColor: accentColor
                                }
                            }}
                            href="/pdf/finance.pdf"
                            download="finance.pdf"
                        >
                            Детальніше
                        </Button>
                    </Box>
                </Grid>
            </Grid>
        </Container>
    );
};

export default Directions;